import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import './App.css';
import Home from './pages/home';
import Dash from "./pages/dash";
import Receivers from "./pages/receivers";
import Account from "./pages/account";
import NotFound from "./pages/NotFound";
import DashboardLayout from "./layouts/dashboard";
import DefaultLayout from "./layouts/default";
import Login from "./pages/login";
import Billets from "./pages/billets";
import { AuthContextProvider } from "./context/Auth";
import ForgotPassword from "./pages/forgot-password";

function App() {
  return (
    <div className="bg-gray-100">
      <AuthContextProvider>
        <Router>
          <Routes>
            {/* Páginas com layout padrão */}
            <Route element={<DefaultLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </Route>

            {/* Páginas com layout de dashboard */}
            <Route element={<DashboardLayout />}>
              <Route path="/dash" element={<Dash />} />
              <Route path="/receivers" element={<Receivers />} />
              <Route path="/billets" element={<Billets />} />
              <Route path="/account" element={<Account />} />
            </Route>

            {/* Rota 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </AuthContextProvider>
    </div>
  );
}

export default App;
